import { Box, Paper, styled } from "@mui/material";

export const ChatContainer = styled(Paper)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  height: "100%",
  width: "100%",
  borderRadius: 10,
  overflow: "hidden",
  backgroundColor: "#fdfdfd",
}));

export const MessagesContainer = styled(Box)(() => ({
  flex: 1,
  overflowY: "auto",
  padding: "10px",
}));

export const MessageRow = styled(Box)(({ sender }) => ({
  display: "flex",
  alignItems: "flex-end",
  marginBottom: "10px",
  justifyContent: sender === "user" ? "flex-start" : "flex-end",
}));

export const MessageBubble = styled(Box)(({ sender, theme }) => ({
  padding: "8px 12px",
  borderRadius: 12,
  maxWidth: "80%",
  wordBreak: "break-word",
  backgroundColor:
    sender === "user"
      ? "#e9ecef"
      : theme.palette.primary.main,
  color: sender === "user" ? "#000" : "#fff",
  fontSize: 14,
  lineHeight: 1.4,
}));

export const InputContainer = styled(Box)(() => ({
  display: "flex",
  alignItems: "center",
  padding: "6px",
  borderTop: "1px solid #ddd",
}));

export const EmptyChatPlaceholder = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  height: "100%",
  gap: 16,
  color: theme.palette.text.disabled,
  fontSize: 14,
  textAlign: "center",

  "& img": {
    width: 120,
    height: 120,
    objectFit: "contain",
  },
}));
